export const PRESENCE_ONLINE_THRESHOLD_MS = 90_000;

export const isStudentOnline = (
  lastSeenAt: string | null | undefined,
): boolean => {
  if (!lastSeenAt) {
    return false;
  }

  const lastSeenMs = new Date(lastSeenAt).getTime();

  if (Number.isNaN(lastSeenMs)) {
    return false;
  }

  return Date.now() - lastSeenMs <= PRESENCE_ONLINE_THRESHOLD_MS;
};

export const getStudentPresenceStatus = (
  lastSeenAt: string | null | undefined,
): 'online' | 'offline' => (isStudentOnline(lastSeenAt) ? 'online' : 'offline');
